import { action } from 'satcheljs/lib/legacy';
export default action('removeMentionAddedRecipient')(function removeMentionAddedRecipient(viewState, indexToRemove) {
    viewState.mentionsAddedRecipients.splice(indexToRemove, 1);
});
//# sourceMappingURL=removeMentionAddedRecipient.js.map